<template>
  <div class="flex flex-col items-start">
    <InputLabel v-if="props.label" :for="id" :optional="!props.required">
      {{ props.label }}
    </InputLabel>
    <BaseInput
      :id="id"
      v-model="value"
      class="input"
      autocomplete="off"
      :disabled="props.disabled"
      :name="props.name"
      :mask="props.mask"
      :placeholder="props.placeholder"
      :required="props.required"
      :type="props.type"
    />
    <InputError :error="errorMessage" />
  </div>
</template>

<script setup lang="ts">
import type { BaseInputProps } from '@/components/base/input/types'
import type { InputProps } from './types'

interface InputTextProps extends BaseInputProps, InputProps {
  type?: 'email' | 'text'
}

const props = withDefaults(defineProps<InputTextProps>(), { type: 'text' })
const { id, value, errorMessage } = useInput<string>(props.name)
</script>
